/* global google, $, grecaptcha */
require("jquery-mask-plugin");
import { showPopupLogin, initLazyLoad, callPinterestAPI } from "@api/utils_2020";
import { exit } from "screenfull";
import 'select2';
import 'select2/dist/css/select2.css'; 

import ("./leadEdit.js");

/*import ( '../../data/lead/lead.css');*/

var isNew = $('div[data-idlead]').length>0?true:false;
if (isNew)
{
    var layout = $('div[data-idlead]').first().data('layout');
}
else
{
    var layout = null;
}

const Lead = {
    error: false,
    captchaValidated: false,
    //storeLead: false,
    //geocode: null,
    init: function() {

        console.log('LEAD started');

        if (isB == 'yes'){
            $('.form--city').hide();
        }

        //if ($('#value2').val())
        //{
        //    Lead.storeLead = true;
        //}

        initLazyLoad();

        
        Lead.initForm();

        showPopupLogin();
            

        $('#lead-form').on("submit", Lead.validateForm);
        //$('#lead-form form').on("submit", Lead.validateForm);
    },

    initForm: function(e) {
        $('#formLead .form--state #state').select2();
        $('#formLead .form--city #city').select2();
        $('#formLead .form--value2 #value2').select2();

        $('.select2-container').on('click', function() {
            $('.select2-search__field').trigger( "focus" );
        });

        $('[data-toggle="tooltip"]').tooltip();
        $("input#cpf").mask("000.000.000-09", {placeholder: "999.999.999-99"});
        $("input#phone").mask("(00) 00000-0009", {placeholder: "(00) 00000-0000"});
        //$("input#phone").mask("(00) 00000-00009", {placeholder: "(__) _____-____"});

        $("input[data-maskf]").each(function(element){
            var options = {};
            var maskF = $(this).data('maskf');
            var validate = $(this).data('validate');
            var placeholder = $(this).data('placeholder');
            if (placeholder)
            {
                var options = { "placeholder": placeholder};
            }
            $(this).mask(maskF, options);
            
            // validação 
            switch (validate)
            {
                case 'cnpj':
                    $(this).on('blur', function(e)
                    {
                        var cnpj = $(this).val();
                        if (cnpj == '') {
                            var errorAlert = 'Preencha seu CNPJ';
                            $(this).parent().find('.field-error').remove();
                            $(this).addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                            $(this).parent().find('.field-error').show();
                            $('button.pbds-btn.dark').attr('disabled',true)
                        } else if (!validaCNPJ(cnpj)) {
                            var errorAlert = 'Preencha o campo com um CNPJ válido';
                            $(this).parent().find('.field-error').remove();
                            $(this).addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                            $(this).parent().find('.field-error').show();
                            $('button.pbds-btn.dark').attr('disabled',true)
                        } else {
                            $(this).removeClass("is-invalid");
                            $(this).parent().find('.field-error').fadeOut('fast',function() {
                                $(this).remove();
                            });
                            $('button.pbds-btn.dark').attr('disabled',false)
                        }
                    });
                    break;
            }
        });
        
        // https://portobello.kanbanize.com/ctrl_board/201/cards/66216/details/
        $('#email').on('blur', function(e){
            /*var idLead = $('#formLead').data('id');
            if (idLead == 32)
            {
                var email = $(this).val();
                console.log(email);
                Util.service("WSPortobelloLead", true, {
                    exceptionHandler: alertInterface.showError,
                    reflectSuccess: function(service) {
                        var hash = service.loadContactByEmail(idLead, email,{ success: function(hash)
                            {
                                if (hash)
                                    window.location.href =  hash;
                            }
                        }
                        );
                        
                    }
                });
            }*/
            if ($("#lead-form input#email").val() == '') {
                var errorAlert = 'Preencha seu e-mail';
                $("#lead-form input#email").parent().find('.field-error').remove();
                $("#lead-form input#email").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#email").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else if (!validateEmail($("#lead-form input#email").val(), true)) {
                var errorAlert = 'Preencha o campo com um e-mail válido';
                $("#lead-form input#email").parent().find('.field-error').remove();
                $("#lead-form input#email").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#email").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else {
                $("#lead-form input#email").removeClass("is-invalid");
                $("#lead-form input#email").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
                $('button.pbds-btn.dark').attr('disabled',false)
            }
        });
        // https://portobello.kanbanize.com/ctrl_board/201/cards/66216/details/
        $('#phone').on('blur', function(e){
            if (!$("#lead-form input#phone").val()) {
                var errorAlert = 'Preencha seu celular';
                $("#lead-form input#phone").parent().find('.field-error').remove();
                $("#lead-form input#phone").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#phone").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else if (!validateMobilePhone($("#lead-form input#phone").val())) {
                var errorAlert = 'Preencha o campo com um telefone válido';
                $("#lead-form input#phone").parent().find('.field-error').remove();
                $("#lead-form input#phone").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#phone").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else {
                $("#lead-form input#phone").removeClass("is-invalid");
                $("#lead-form input#phone").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
                $('button.pbds-btn.dark').attr('disabled',false)
            }
        });


        $('#name').on('blur', function(e){
            if (!$("#lead-form input#name").val()) {
                var errorAlert = 'Preencha seu seu nome';
                $("#lead-form input#name").parent().find('.field-error').remove();
                $("#lead-form input#name").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#name").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else if (!Lead.validateName($("#lead-form input#name").val())) {
                var errorAlert = 'Preencha o campo com seu nome completo';
                $("#lead-form input#name").parent().find('.field-error').remove();
                $("#lead-form input#name").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#name").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else {
                $("#lead-form input#name").removeClass("is-invalid");
                $("#lead-form input#name").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
                $('button.pbds-btn.dark').attr('disabled',false)
            }
        });

        // https://portobello.kanbanize.com/ctrl_board/201/cards/66373/details/
        $('#cpf').on('blur', function(e){
           
            if ($("#lead-form input#cpf").val() == '') {
                var errorAlert = 'Preencha seu CPF';
                $("#lead-form input#cpf").parent().find('.field-error').remove();
                $("#lead-form input#cpf").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#cpf").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else if (!validateCpf($("#lead-form input#cpf").val(), true)) {
                var errorAlert = 'Preencha o campo com um CPF válido';
                $("#lead-form input#cpf").parent().find('.field-error').remove();
                $("#lead-form input#cpf").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#cpf").parent().find('.field-error').show();
                $('button.pbds-btn.dark').attr('disabled',true)
            } else {
                $("#lead-form input#cpf").removeClass("is-invalid");
                $("#lead-form input#cpf").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
                $('button.pbds-btn.dark').attr('disabled',false)
            }
        });

        $('#city, label.city, label.city .jsTip').on('click',function(e){
            e.preventDefault();
            //if (isB == 'no' && (!$("#lead-form select#state").val()) ){
            if ((!$("#lead-form select#state").val()) ){
                var errorAlert = 'Escolha o estado';
                $("#lead-form select#state").parent().find('.field-error').remove();
                $("#lead-form select#state").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
            }
            return false;
        })

        $('#value2 ,label.form--value2, label.form--value2 .jsTip').on('click',function(e){
            e.preventDefault();
            if ((!$("#lead-form select#state").val()) ){
                var errorAlert = 'Escolha o estado';
                $("#lead-form select#state").parent().find('.field-error').remove();
                $("#lead-form select#state").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
            }

            if ((!$("#lead-form select#city").val()) ){
                var errorAlert = 'Escolha a cidade';
                $("#lead-form select#city").parent().find('.field-error').remove();
                $("#lead-form select#city").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
            }
            return false;
        })

        
        $('#state').on('change', function(e){
            e.preventDefault();

            $("#lead-form select#state").removeClass("is-invalid");
            $("#lead-form select#state").parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });

            var estado = $(this).val();

            if ($('#state').val() != '' && isB == 'yes'){
                $('.form--city').removeClass('d-none');
                $('.form--city').show();
            }

            var city = $('#city').data('value');
            $('#city').html('<option value="">Carregando...</option>');
            $('#city').prop('disabled', true);
            $('#city').parent().removeClass('disabled');
            $.get( `/data/ibge/${estado}.json`, function( data ) {    
                $('#city').html('<option value="none">Escolha...</option>');
                var selected = '';
                data.forEach(function(value, index, array)                
                {
                    $('#city').append('<option value="'+value.nome+'" '+selected+'>'+value.nome+'</option>')    
                });
                $('#city').prop('disabled', false);
                // if (city == value.nome) {
                    //força a seleção da primeira cidade ao trocar o estado
                    $('#city option:eq(0)').prop('selected', true);
                // } 
                
            }, "json" );

         

            if ($("#lead-form #value2").val() == null || $("#lead-form #value2").val()=='' && ($('#city').val() != 'none' || !$('#city').val())){
                $('button.pbds-btn.dark').attr('disabled',true)
                // $('button.pbds-btn.dark').css('opacity',1)
            }


            return false;
        });

        if ($('#state').data('value'))
        {
                $('#state').trigger('change');
        }
        if (!isNew)
        {
            $('.form--value2').hide();
        }


        $('body').on('change', '#city', function searchStores() {

            if ($('#city').val() == 'none' || !$('#city').val()){
                $('button.pbds-btn.dark').attr('disabled',true)
                return false;
            } else 
            // console.log('trocou de cidade')
            var lastText = $('button.pbds-btn.dark').text();
            $('button.pbds-btn.dark').attr('disabled',true)
            // $('button.pbds-btn.dark').css('opacity',1)
            $('button.pbds-btn.dark').text('carregando...')

            const query = $(this).val();
            const state = $("#state").val();
            const options = $('#value2');
            $('input[name="urbe"]').val(query);

            $("#lead-form select#city").removeClass("is-invalid");
                $("#lead-form select#city").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });

            var storeEnabled = $(this).attr('data-storeEnabled');
            
            if(typeof storeEnabled != undefined && storeEnabled != 'true' ){
                options.removeAttr('required');
                options.removeClass("is-invalid");
                options.parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                $('.form--value2').hide();
                // return false;
            }
        

            const defaultOpt = `<option class="storeOption" disabled selected>Procurando...</option>`;
            options.html(defaultOpt);
   
            var pbShopAPI = Util.service('WSSalesChannel', true, {
                withCredentials: true,
                reflectSuccess(service) {
                pbShopAPI = service;
                pbShopAPI.getSalesChannelFromQuery(query, 'cidade', [4], 1500, null, {
                    success(stores) {
                    if (stores.length > 0) {
                        options.attr('required', 'true');
                        $('.form--value2').show();
                        const defaultOpt = `<option class="storeOption" disabled selected></option>`;
                        options.html(defaultOpt);
                        var selected = null;
                        if(stores.length == 1){
                            selected = 'selected';
                        }
                        stores.forEach(store => {
                            if (store.state_acronym == state)
                            {
                                const newOption = `<option class="storeOption" ${selected} value="${store.cnpj} - PORTOBELLO SHOP ${store.name}">PORTOBELLO SHOP ${store.name}</option>`;
                                options.append(newOption);
                            }
                        });
                        $('.form--nome.store').show();
                        options.focus();
                        options.prop('disabled', false);
                        options.parent().removeClass('disabled');
                        options.removeAttr('disabled');
                        $('.form--nome.store').show();
                        options.focus();
                        options.prop('disabled', false);
                        options.removeAttr('disabled');
                        options.parent().removeClass('disabled');
                        if (stores.length > 1)
                        {
                            $("select#value2.form-control option:selected").text('Selecione a loja mais próxima...');
                        }

                    } else {
                        pbShopAPI.getSalesChannelFromQuery(state, 'estado', [4], 1500, null, {
                            success(stores) {
                            if (stores.length > 0) {
                                console.log('o estado tem lojas')
                                options.attr('required', 'true');
                                $('.form--value2').show();
                                const defaultOpt = `<option class="storeOption" disabled selected></option>`;
                                options.html(defaultOpt);
                                var selected = null;
                                if(stores.length == 1){
                                    selected = 'selected';
                                }
                                stores.forEach(store => {
                                    if (store.state_acronym == state)
                                    {
                                        const newOption = `<option class="storeOption" ${selected} value="${store.cnpj} - PORTOBELLO SHOP ${store.name}">PORTOBELLO SHOP ${store.name}</option>`;
                                        options.append(newOption);
                                    }
                                });
                                $('.form--nome.store').show();
                                options.focus();
                                options.prop('disabled', false);
                                options.removeAttr('disabled');
                                options.parent().removeClass('disabled');
                                if (stores.length > 1)
                                {
                                    $("select#value2.form-control option:selected").text('Selecione a loja mais próxima...');
                                }

                            } else {
                                console.log('o estado não tem lojas')
                                options.removeAttr('required');
                                $('.form--value2').hide();
                                const defaultOpt = `<option class="storeOption" disabled selected>Nenhuma loja encontrada</option>`;
                                options.html(defaultOpt);
                                options.prop('disabled', true);
                                options.parent().addClass('disabled');

                            }
                            },
                        });
                    }
                        if ($('#city').val() != 'none' || !$('#city').val()){
                            $('button.pbds-btn.dark').attr('disabled',false)
                            $('button.pbds-btn.dark').css('pointer-events','all')
                            $('button.pbds-btn.dark').text(lastText)
                        }
                    },
                });
                },
            });
        });
    
        $("#lead-form input#politica").off('change').on('change',function(e)
        {
            if ($("#lead-form #value2").val()){
                $('#lead-form form button[type="submit"]').prop("disabled", false);
                $('button.pbds-btn.dark').css('pointer-events','all')
            }
            $(this).removeClass("is-invalid");
            $(this).parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });
        });
        $("#lead-form input#name").off('change').on('change',function(e)
        {
            if ($("#lead-form #name").val() && Lead.validateName($("#lead-form #name").val())){
                $('#lead-form form button[type="submit"]').prop("disabled", false);
                $('button.pbds-btn.dark').css('pointer-events','all')
            }
            $(this).removeClass("is-invalid");
            $(this).parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });
        });
        $("#lead-form select#value1").off('change').on('change',function(e)
        {
            $(this).removeClass("is-invalid");
            $(this).parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });
            var text = $('.form-submit button[type=submit]').data('text');
            if(text == ''){
                text = "Enviar dados";
            }
            if ($("#lead-form #value2").val()){
                $('button.pbds-btn.dark').css('pointer-events','all')
                $('.form-submit button[type=submit]')
                .removeProp("disabled")
                .removeClass("jsDisableButton")
                .css("cursor", "").html(text);
            }
        });
        $("#lead-form input#email,#lead-form input#name").off('keydown').on('keydown',function(e)
        {
            $(this).removeClass("is-invalid");
            $(this).parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });
        });
        
        $("#lead-form input#email").off('change').on('change',function(e)
        {
            if ($("#lead-form #value2").val()){
                $('#lead-form form button[type="submit"]').prop("disabled", false);
                $('button.pbds-btn.dark').css('pointer-events','all')
            }
            $(this).removeClass("is-invalid");
            $(this).parent().find('.field-error').fadeOut('fast',function() {
                $(this).remove();
            });
        });
    },
    
    validateName: function(name)
    {
        var parts = name.split(' ');
        if (name && parts.length > 1 && parts[0].length >= 3 )
        {
            return true;
        }
        else
            return false;
    },
    validateForm: function(e) {
        //e.preventDefault();
        //e.stopPropagation();
        var button = $('#lead-form button[type="submit"]');
        var successUrl = button.data('url');
        var submitMessage = "Registrando. Aguarde...";
        if (successUrl)
        {
            if (successUrl.indexOf('pdf') > 0)
            {
                submitMessage = 'Download iniciado...';
                setTimeout(function()
                {
                    var text = button.data('text');
                    if(text == ''){
                        text = "Enviar dados";
                    }
                    if ($("#lead-form #value2").val()){
                        $('button.pbds-btn.dark').css('pointer-events','all')
                        button
                            .prop("disabled",'')
                            .removeClass("jsDisableButton")
                            .css("cursor", "")
                            .html(text);
                    }
                }, 5000);
            }
        }
        
        button
            .prop("disabled", "disabled")
            .addClass("jsDisableButton")
            .css("cursor", "not-allowed")
            .html(submitMessage);

        var city = $("#city");
        var stateSelect = $("#state");
        var profession = $("#value1");
        var store = $("#value2");
        var interest = $("#interest");
        
        if (
            ($("#lead-form input#email").val() == '' || !validateEmail($("#lead-form input#email").val(), true)) ||
            ($("#lead-form input#cpf").length > 0 && ($("#lead-form input#cpf").val() == '' || !validateCpf($("#lead-form input#cpf").val(), true))) ||
            (!$("#lead-form input#name").val() || !Lead.validateName($("#lead-form #name").val())) ||
            (stateSelect.prop('required')  && !stateSelect.val() ) || (city.prop('required')  && !city.val()) ||
            (city.length > 0 && city.val() && city.attr('data-storeEnabled') == 'true' && store.prop('required')  && !store.val()) ||
            ($("#lead-form input#phone").length > 0 && ($("#lead-form input#phone").val() == '' || !validateMobilePhone($("#lead-form input#phone").val()))) ||
            ($("#lead-form #value1").length > 0 && !$("#lead-form #value1").val())  ||
            !$("#lead-form input#politica").is(":checked") || 
            (interest.prop('required')  && !interest.val())
        ) {

            if (!$("#lead-form input#name").val() || !Lead.validateName($("#lead-form #name").val())) {
                var errorAlert = 'Preencha seu nome completo';
                $("#lead-form input#name").parent().find('.field-error').remove();
                $("#lead-form input#name").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#name").parent().find('.field-error').show();
            } else {
                $("#lead-form input#name").removeClass("is-invalid");
                $("#lead-form input#name").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
            }

            if ($("#lead-form select#state").length > 0 && !$("#lead-form select#state").val()) {
                var errorAlert = 'Escolha o estado';
                $("#lead-form select#state").parent().find('.field-error').remove();
                $("#lead-form select#state").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
            }

            if ($("#lead-form select#city").length > 0 &&  !$("#lead-form select#city").val()) {
                var errorAlert = 'Escolha a cidade';
                $("#lead-form select#city").parent().find('.field-error').remove();
                $("#lead-form select#city").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
            }

            if ($("#lead-form input#email").val() == '') {
                var errorAlert = 'Preencha seu e-mail';
                $("#lead-form input#email").parent().find('.field-error').remove();
                $("#lead-form input#email").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#email").parent().find('.field-error').show();
            } else if (!validateEmail($("#lead-form input#email").val(), true)) {
                var errorAlert = 'Preencha o campo com um e-mail válido';
                $("#lead-form input#email").parent().find('.field-error').remove();
                $("#lead-form input#email").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                $("#lead-form input#email").parent().find('.field-error').show();
            } else {
                $("#lead-form input#email").removeClass("is-invalid");
                $("#lead-form input#email").parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
            }
            if ($("#lead-form input#cpf").length > 0)
            {
                if ($("#lead-form input#cpf").val() == '') {
                    var errorAlert = 'Preencha seu CPF';
                    $("#lead-form input#cpf").parent().find('.field-error').remove();
                    $("#lead-form input#cpf").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form input#cpf").parent().find('.field-error').show();
                    $('button.pbds-btn.dark').attr('disabled',true)
                } else if (!validateCpf($("#lead-form input#cpf").val(), true)) {
                    var errorAlert = 'Preencha o campo com um CPF válido';
                    $("#lead-form input#cpf").parent().find('.field-error').remove();
                    $("#lead-form input#cpf").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form input#cpf").parent().find('.field-error').show();
                    $('button.pbds-btn.dark').attr('disabled',true)
                } else {
                    $("#lead-form input#cpf").removeClass("is-invalid");
                    $("#lead-form input#cpf").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                    $('button.pbds-btn.dark').attr('disabled',false)
                }
            }


            if ($("#lead-form input#phone").length > 0)
            {            
                if (!$("#lead-form input#phone").val()) {
                    var errorAlert = 'Preencha seu celular';
                    $("#lead-form input#phone").parent().find('.field-error').remove();
                    $("#lead-form input#phone").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form input#phone").parent().find('.field-error').show();
                } else if (!validateMobilePhone($("#lead-form input#phone").val())) {
                    var errorAlert = 'Preencha o campo com um telefone válido';
                    $("#lead-form input#phone").parent().find('.field-error').remove();
                    $("#lead-form input#phone").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form input#phone").parent().find('.field-error').show();
                } else {
                    $("#lead-form input#phone").removeClass("is-invalid");
                    $("#lead-form input#phone").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }
            }

            if ($("#lead-form #value1").length > 0)
            {
                if ( !$("#lead-form #value1").val()) {
                    var errorAlert = 'Preencha este campo';
                    $("#lead-form #value1").parent().find('.field-error').remove();
                    $("#lead-form #value1").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form #value1").parent().find('.field-error').show();
                } else {
                    $("#lead-form #value1").removeClass("is-invalid");
                    $("#lead-form #value1").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }
            }
            
            var city = $("#city");
            var store = $("#value2");
            if(city.length > 0 && city.val() && city.attr('data-storeEnabled') == 'true' && store.prop('required')){
                if(!store.val()){
                    var errorAlert = 'Selecione uma loja';
                    store.parent().find('.field-error').remove();
                    store.addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    store.parent().find('.field-error').show();
                }else{
                    store.removeClass("is-invalid");
                    store.parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }
            }
            
            if(interest){
                if(!interest.val()){
                    var errorAlert = 'Selecione um interesse';
                    interest.parent().find('.field-error').remove();
                    interest.addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    interest.parent().find('.field-error').show();
                }else{
                    interest.removeClass("is-invalid");
                    interest.parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }
            }

            if (!$("#lead-form input#politica").is(":checked")) {                
                var errorAlert = 'Você precisa concordar com a Política de Privacidade!';
                $("#lead-form input#politica").addClass("is-invalid");
                $("#lead-form input#politica").closest('label').parent().find('.field-error').remove();
                $("#lead-form input#politica").closest('label').after('<div class="field-error">'+errorAlert+'</div>');
            } else {
                $("#lead-form input#politica").removeClass("is-invalid");
                $("#lead-form input#politica").closest('label').parent().find('.field-error').fadeOut('fast',function() {
                    $(this).remove();
                });
            }

            var text = button.data('text');
            if(text == ''){
                text = "Enviar dados";
            }
            $('button.pbds-btn.dark').css('pointer-events','all')
            button
                .prop("disabled",'')
                .removeClass("jsDisableButton")
                .css("cursor", "")
                .html(text);
            if (typeof errorAlert != 'undefined' && errorAlert)
            {

                $("#lead-form form button[type=submit]").off('click').on('click', function()
                {
                    $("#lead-form form").submit();
                });
            }
            else
            {
                $("#lead-form form button[type=submit]").off('click');
            }
        } else {
            button
            .removeProp("disabled");
            if (($("#lead-form input#phone").length > 0 && !$("#lead-form input#phone").val()) || ($("#lead-form select#state").length > 0 && !$("#lead-form select#state").val()) || ($("#lead-form select#city").length > 0 && $("#lead-form select#city").is(':disabled')) || ($("#lead-form select#city").length > 0 && !$("#lead-form select#city").is(':disabled') && $("#lead-form select#city").val() == "none")) {

                if (!$("#lead-form input#phone").val()) {
                    var errorAlert = 'Preencha seu celular';
                    $("#lead-form input#phone").parent().find('.field-error').remove();
                    $("#lead-form input#phone").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                    $("#lead-form input#phone").parent().find('.field-error').show();
                } else {
                    $("#lead-form input#phone").removeClass("is-invalid");
                    $("#lead-form input#phone").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }

                if ($("#lead-form select#state").length > 0 && !$("#lead-form select#state").val()) {
                    var errorAlert = 'Escolha o estado';
                    $("#lead-form select#state").parent().find('.field-error').remove();
                    $("#lead-form select#state").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                } else {
                    $("#lead-form select#state").removeClass("is-invalid");
                    $("#lead-form select#state").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }

                if ($("#lead-form select#city").length > 0 &&  $("#lead-form select#city").val() == "none") {
                    var errorAlert = 'Escolha a cidade';
                    $("#lead-form select#city").parent().find('.field-error').remove();
                    $("#lead-form select#city").addClass('is-invalid').after('<div class="field-error">'+errorAlert+'</div>');
                } else {
                    $("#lead-form select#city").removeClass("is-invalid");
                    $("#lead-form select#city").parent().find('.field-error').fadeOut('fast',function() {
                        $(this).remove();
                    });
                }
                
                $('button.pbds-btn.dark').css('pointer-events','all')
                    .prop("disabled",'')
                    .removeClass("jsDisableButton")
                    .css("cursor", "")
                    .html("Baixe Agora");
           
            } else {    
                pintrk('track', 'lead', {
                    event_id: eventID,
                    lead_type: 'Newsletter'
                });
                callPinterestAPI('lead', { lead_type: 'Newsletter' });
                window.dataLayer.push({
                    'event': "lp_lead",
                    params: {
                    'Estado': stateSelect.val(),
                    'Cidade': city.val(),
                    'Profissao': profession.val(),
                    'page_path': window.location.href
                    }
                });
                return true;
            }    
        }

        return false;
    },
};

/* harmony default export */ __webpack_exports__["default"] = (() => {
    setTimeout(() => {
        Lead.init();    
    }, 1000);
    
});

window.validateCaptcha = function(token)
{

    if(token) {
        if (1
/*            $("#lead-form input#email").val() &&
            $("#lead-form input#name").val() &&
            $("#lead-form input#politica").is(":checked")
            */
        ) {
            //$('#lead-form form button[type="submit"]').click();
            $("#lead-form form").submit();
        }
    }

    return false;

}


function validateCpf(cpf) {
    var service = Util.service('WSUtil', false);

        console.log(service);

        var result =  service.validateCpf(cpf);
        //console.log(result);
        if (result)
        {
            return true;
        }
        else
        {
            UtilUi.alert({ title: 'CPF inválido', message: 'Verifique o CPF digitado, pois este não é válido' }, 'error');
        }
}

window.validateCpf = validateCpf;


function validaCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g,'');

  if(cnpj == '') return false;

  if (cnpj.length != 14)
    return false;

  // Elimina CNPJs invalidos com todos os digitos iguais
  if (/^(\d)\1{13}$/.test(cnpj))
    return false;

  // Valida Dígitos Verificadores
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0,tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;
}